import { Injectable } from '@angular/core';
import { Api, User } from '../'

@Injectable()
export class Advance {

  list:any;  
  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) { 
      return this.api.get('index.php/advance/advance', params);
  }

  getDetail(params?: any) {
      return this.api.get('index.php/advance/master/detail', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/advance_providers/advance/advance.ts